/* eslint-disable camelcase */
import { WishList, WishListItem } from '../../models';
import { GET_WISH_LIST, RESET_WISH_LIST } from '../constants/wishList';

const convertItem = (item, quantity, item_price, item_price_with_fee) => {
  return new WishListItem(
    item.id,
    item.name,
    item.price,
    item.price_with_fee,
    item.typ,
    quantity,
    item_price,
    item_price_with_fee,
  );
};

// eslint-disable-next-line import/prefer-default-export
export const getWishList = (data) => {
  const { wish_list } = data;
  if (!wish_list) {
    return (dispatch) => {
      dispatch({ type: RESET_WISH_LIST });
    };
  }

  const { id, items } = wish_list;

  const convertedItems = items.map((element) => {
    const { item, quantity, item_price, item_price_with_fee } = element;
    return convertItem(item, quantity, item_price, item_price_with_fee);
  });

  const wishList = new WishList(id, convertedItems);
  return (dispatch) => {
    dispatch({
      type: GET_WISH_LIST,
      ...wishList,
    });
  };
};
